import types from "./types";

const INITIAL_STATE = {
  clientrequestList: null,
  clientrequestListError: null,
  clientrequestListLoading: false,

  //create
  createclientrequest: null,
  createclientrequestError: null,
  createclientrequestLoading: false,

  //update
  updateclientrequest: null,
  updateclientrequestError: null,
  updateclientrequestLoading: false,

  //delete
  deleteclientrequest: null,
  deleteclientrequestError: null,
  deleteclientrequestLoading: false,

  //single item
  singleItem: null,
};

const clientrequestReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_CLIENT_REQUEST_START:
      return {
        ...state,
        clientrequestList: null,
        clientrequestListError: null,
        clientrequestListLoading: true,
      };
    case types.GET_CLIENT_REQUEST_SUCCESS:
      return {
        ...state,
        clientrequestList: action.payload,
        clientrequestListLoading: false,
      };
    case types.GET_CLIENT_REQUEST_ERROR:
      return {
        ...state,
        clientrequestListError: action.payload,
        clientrequestListLoading: false,
      };
    case types.GET_CLIENT_REQUEST_RESET:
      return {
        ...state,
        clientrequestListError: null,
        clientrequestListLoading: false,
      };
    //create

    case types.CREATE_CLIENT_REQUEST_START:
      return {
        ...state,
        createclientrequest: null,
        createclientrequestError: null,
        createclientrequestLoading: true,
      };
    case types.CREATE_CLIENT_REQUEST_SUCCESS:
      return {
        ...state,
        createclientrequest: action.payload,
        createclientrequestLoading: false,
      };
    case types.CREATE_CLIENT_REQUEST_ERROR:
      return {
        ...state,
        createclientrequestError: action.payload,
        createclientrequestLoading: false,
      };
    case types.CREATE_CLIENT_REQUEST_RESET:
      return {
        ...state,
        createclientrequestError: null,
        createclientrequestLoading: false,
      };
    //delete

    case types.DELETE_CLIENT_REQUEST_START:
      return {
        ...state,
        deleteclientrequest: null,
        deleteclientrequestError: null,
        deleteclientrequestLoading: true,
      };
    case types.DELETE_CLIENT_REQUEST_SUCCESS:
      return {
        ...state,
        deleteclientrequest: action.payload,
        deleteclientrequestLoading: false,
      };
    case types.DELETE_CLIENT_REQUEST_ERROR:
      return {
        ...state,
        deleteclientrequestError: action.payload,
        deleteclientrequestLoading: false,
      };
    case types.DELETE_CLIENT_REQUEST_RESET:
      return {
        ...state,
        deleteclientrequest: null,
        deleteclientrequestError: null,
        deleteclientrequestLoading: false,
      };

    //update
    case types.UPDATE_CLIENT_REQUEST_START:
      return {
        ...state,
        updateclientrequest: null,
        updateclientrequestError: null,
        updateclientrequestLoading: true,
      };
    case types.UPDATE_CLIENT_REQUEST_SUCCESS:
      return {
        ...state,
        updateclientrequest: action.payload,
        updateclientrequestLoading: false,
      };
    case types.UPDATE_CLIENT_REQUEST_ERROR:
      return {
        ...state,
        updateclientrequestError: action.payload,
        updateclientrequestLoading: false,
      };
    case types.UPDATE_CLIENT_REQUEST_RESET:
      return {
        ...state,
        updateclientrequest: null,
        updateclientrequestError: null,
        updateclientrequestLoading: false,
      };
    //singleItem
    case types.SINGLE_CLIENT_REQUEST_START:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: true,
      };
    case types.SINGLE_CLIENT_REQUEST_SUCCESS:
      return {
        ...state,
        singleItem: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_CLIENT_REQUEST_ERROR:
      return {
        ...state,
        singleItemError: action.payload,
        singleItemLoading: false,
      };
    case types.SINGLE_CLIENT_REQUEST_RESET:
      return {
        ...state,
        singleItem: null,
        singleItemError: null,
        singleItemLoading: false,
      };

    default:
      return { ...state };
  }
};

export default clientrequestReducer;

